import { useState } from "react";
import { FALLBACK_IMG } from "@/lib/products";

// Image with graceful branded fallback if the remote source fails.
export const SmartImage = ({ src, alt, className, ...props }) => {
  const [current, setCurrent] = useState(src);
  return (
    <img
      src={current}
      alt={alt || ""}
      loading="lazy"
      onError={() => {
        if (current !== FALLBACK_IMG) setCurrent(FALLBACK_IMG);
      }}
      className={className}
      {...props}
    />
  );
};

export default SmartImage;
